module.exports = __webpack_public_path__ + "img/route_nodata_up.2eaba39b.png";